// $(document).ready(function() {
//   // When any preview FAQ question is clicked
//   $('.previw_faq .acc_new-head').on('click', function() {
    
//     // Select the full FAQ container
//     var target = $('.page-width.custom_faq.main_faq');

//     if(target.length) {
//       // Optional: sticky header offset
//       var headerOffset = 100; // adjust as needed
//       var targetPosition = target.offset().top - headerOffset;

//       // Animate scroll
//       $('html, body').animate({
//         scrollTop: targetPosition
//       }, 600); // 600ms animation
//     }
//   });
// });
// $(document).ready(function() {
//   $('.previw_faq .acc_new-head').on('click', function() {
//     var questionText = $(this).text().trim();

//     // Target full FAQ container
//     var faqSection = $('.page-width.custom_faq.main_faq');

//     if(faqSection.length) {
//       // Scroll to FAQ section with offset for sticky header if needed
//       var headerOffset = 100; // adjust if you have sticky header
//       var targetPosition = faqSection.offset().top - headerOffset;

//       $('html, body').animate({
//         scrollTop: targetPosition
//       }, 600);

//       // Check if question exists in full FAQ
//       var found = false;
//       faqSection.find('.acc-head').each(function() {
//         if($(this).text().trim() === questionText) {
//           // Open the matched question
//           faqSection.find('.acc-content').slideUp();
//           faqSection.find('.acc-head').removeClass('active');

//           $(this).siblings('.acc-content').slideDown();
//           $(this).addClass('active');

//           found = true;
//           return false; // break loop
//         }
//       });

//       // If not found, just scroll to FAQ section
//       // Already scrolled above
//     }
//   });
// });

// $(document).ready(function () {
// console.log("running")
//   function normalizeText(text) {
//     return text.replace(/\s+/g, ' ')
//                .replace(/\u00A0/g, ' ')
//                .trim()
//                .toLowerCase();
//   }

//   $('.previw_faq .acc_new-head').on('click', function (e) {
//     console.log("clicked")
//     // e.preventDefault();
//     // e.stopPropagation();

//     var clickedText = normalizeText($(this).find('p').text());
//     console.log('Clicked:', clickedText);

//     var faqSection = document.querySelector('.page-width.custom_faq');
//     if (!faqSection) {
//       console.warn('FAQ section not found');
//       return;
//     }

//     // 🔹 FIXED SCROLL (native, cannot be overridden)
//     var headerOffset = 120;
//     var y = faqSection.getBoundingClientRect().top + window.pageYOffset - headerOffset;

//     window.scrollTo({
//       top: y,
//       behavior: 'smooth'
//     });

//     // 🔹 WAIT for scroll to finish, THEN open accordion
//     setTimeout(function () {

//       $('.acc-content').slideUp();
//       $('.acc-head').removeClass('active');

//       var found = false;

//       $('.page-width.custom_faq .acc-head').each(function () {
//         var mainText = normalizeText($(this).find('p').text());

//         if (mainText === clickedText) {
//           console.log('MATCH FOUND:', mainText);
//           $(this).addClass('active');
//           $(this).siblings('.acc-content').slideDown();
//           found = true;
//           return false;
//         }
//       });

//       if (!found) {
//         console.warn('No matching FAQ question found');
//       }

//     }, 500); // delay ensures scroll completes

//   });

// });

// $(document).ready(function () {

//   function normalizeText(text) {
//     return text
//       .replace(/\s+/g, ' ')
//       .replace(/\u00A0/g, ' ')
//       .trim()
//       .toLowerCase();
//   }

//   $('.acc_new-container.previw_faq .acc_new-head').on('click', function () {

//     var clickedText = normalizeText($(this).find('p').text());
//     console.log('Clicked:', clickedText);

//     var $faqSection = $('.page-width.custom_faq');
//     if (!$faqSection.length) return;

//     // ✅ SCROLL — GemPages SAFE
//     $faqSection[0].scrollIntoView({
//       behavior: 'auto',   // IMPORTANT (smooth breaks in GemPages)
//       block: 'start'
//     });

//     // Optional offset for sticky header
//     setTimeout(function () {
//       window.scrollBy(0, -120);
//     }, 0);

//     // ✅ OPEN ACCORDION AFTER SCROLL
//     setTimeout(function () {

//       $('.acc-content').slideUp();
//       $('.acc-head').removeClass('active');

//       $('.page-width.custom_faq .acc-head').each(function () {
//         var mainText = normalizeText($(this).find('p').text());

//         if (mainText === clickedText) {
//           console.log('MATCH FOUND:', mainText);
//           $(this).addClass('active');
//           $(this).siblings('.acc-content').slideDown();
//           return false;
//         }
//       });

//     }, 100);

//   });

// });
function smoothScrollTo(targetY, duration = 700) {
  const startY = window.pageYOffset;
  const distance = targetY - startY;
  let startTime = null;

  function animation(currentTime) {
    if (!startTime) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);

    // easeInOut
    const ease = progress < 0.5
      ? 2 * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 2) / 2;

    window.scrollTo(0, startY + distance * ease);

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  }

  requestAnimationFrame(animation);
}

$(document).ready(function () {

  function normalizeText(text) {
    return text
      .replace(/\s+/g, ' ')
      .replace(/\u00A0/g, ' ')
      .trim()
      .toLowerCase();
  }

  $('.previw_faq .acc_new-head').on('click', function () {

    var clickedText = normalizeText($(this).find('p').text());

    var $faqSection = $('#shopify-section-template--28149959491926__faq_nTPPYL');
    if (!$faqSection.length) return;

    var headerOffset = 120;
    var targetY = $faqSection.offset().top - headerOffset;

    // ✅ SMOOTH SCROLL (GemPages SAFE)
    smoothScrollTo(targetY, 800);

    // ✅ OPEN ACCORDION AFTER SCROLL
    setTimeout(function () {

      $('#shopify-section-template--28149959491926__faq_nTPPYL .acc-content').slideUp();
      $('#shopify-section-template--28149959491926__faq_nTPPYL .acc-head').removeClass('active');

      $('#shopify-section-template--28149959491926__faq_nTPPYL .acc-head').each(function () {

        if (normalizeText($(this).find('p').text()) === clickedText) {
          $(this).addClass('active');
          $(this).siblings('.acc-content').slideDown();
          return false;
        }
      });

    }, 850);

  });

});


$(document).ready(function () {
console.log("console")
  function updatePrice() {
    // Get the selected option in the dropdown
    var selectedOption = $('select[name="id"] option:selected');
    if (!selectedOption.length) return;

    // Get price from data attribute
    var priceCents = selectedOption.data('price');
    if (!priceCents) return;

    // Convert cents to euros
    var price = (priceCents / 100).toFixed(2).replace('.', ',');

    // Update sticky price
    $('.total-sticky-price .money').text('€' + price);

    // Update main price
    $('.price_custom').text('€' + price + ' EUR');
  }

  // Wait until Shopify scripts finish updating prices
  function waitForStickyPrice() {
    let priceText = $('span.total-sticky-price .money').text();
    if (priceText && priceText.trim() !== '') {
      // Use the current sticky price on page load
      $('.price_custom').text(priceText);
    } else {
      // If not ready yet, check again shortly
      setTimeout(waitForStickyPrice, 50);
    }
  }

  // Initialize price on page load
  waitForStickyPrice();

  // Update when dropdown changes
  $(document).on('change', 'select[name="id"]', updatePrice);

});

$(document).on('change', 'select[name="id"]', function () {
  var selectedOptioncsrt = $(this).find('option:selected');
  var priceCentscsrt = selectedOptioncsrt.data('price');

  if (!priceCentscsrt) return;

  // Convert cents to euros
  var pricecsrt = (priceCentscsrt / 100).toFixed(2).replace('.', ',');

  // Update sticky price
  $('.total-sticky-price .money').text('€' + pricecsrt);

  // Update main price
  $('.price_custom').text('€' + pricecsrt);
});